module.exports = __webpack_public_path__ + "img/20220219_073451.c9d05da0.jpg";